import { Collection } from "@tblabs/truffle";
import { BlogArticle } from "./BlogArticle";


export class BlogContent
{
    public Id = "";
    public Articles = new Collection<BlogArticle>();

    public ArticleByUrl(url: string): BlogArticle
    {
        const article = this.Articles.Items.find(x => x.Url.value == url);

        if (!article)
        {
            throw new Error(`Nie znaleziono artykułu pod wskazanym adresem. To oznacza jakąś awarie albo błędny link...`);
        }

        return article;
    }
}
